export const AssessmentLevels = {
  NONE: 'NONE',
  EMERGENCY: 'EMERGENCY',
  EMERGENCY_SUSPECT: 'EMERGENCY_SUSPECT',
  URGENCY: 'URGENCY',
  RELATIVE_URGENCY: 'RELATIVE_URGENCY',
  INDIRECT_HEALTH: 'INDIRECT_HEALTH'
}

export const AssessmentNames = {
  NONE: 'Sem classificação',
  EMERGENCY: 'Emergência',
  EMERGENCY_SUSPECT: 'Suspeita de emergência',
  URGENCY: 'Urgência',
  RELATIVE_URGENCY: 'Urgência relativa',
  INDIRECT_HEALTH: 'Saúde indireta'
}

export const PillarsTabs = {
  CHATS: 'chats',
  SCREENING: 'screening',
  CHANNELS: 'channels',
  FOLLOW_UP: 'followUp',
  MENTION: 'mention',
  ARCHIVED: 'archived'
}

/**
 * Channel classification
 */
export const CHANNEL_KINDS = {
  CHAT: 'CHAT',
  CHANNEL: 'CHANNEL'
}

export const CHANNEL_CATEGORIES = {
  ASSISTANCE: 'ASSISTANCE',
  ADMINISTRATIVE: 'ADMINISTRATIVE'
}

export const CHANNEL_SUBCATEGORIES = {
  ACUTE: 'ACUTE',
  LONGITUDINAL: 'LONGITUDINAL',
  MULTI: 'MULTI',
  VIRTUAL_CLINIC: 'VIRTUAL_CLINIC',
  SCREENING: 'SCREENING'
}

export const CHANNEL_SUBCATEGORY_CLASSIFIERS = {
  HEALTH_TEAM: 'HEALTH_TEAM',
  NUTRITION: 'NUTRITION',
  PHYSICAL_PREPARATION: 'PHYSICAL_PREPARATION',
  PSYCHOLOGY: 'PSYCHOLOGY',
  AI: 'AI'
}

export const CHANNEL_KINDS_LABEL = {
  [CHANNEL_KINDS.CHAT]: 'Chat',
  [CHANNEL_KINDS.CHANNEL]: 'Canal'
}

export const CHANNEL_CATEGORIES_LABEL = {
  [CHANNEL_CATEGORIES.ASSISTANCE]: 'Assistencial',
  [CHANNEL_CATEGORIES.ADMINISTRATIVE]: 'Administrativo'
}

export const CHANNEL_SUBCATEGORIES_LABEL = {
  [CHANNEL_SUBCATEGORIES.ACUTE]: 'Agudo',
  [CHANNEL_SUBCATEGORIES.LONGITUDINAL]: 'Longitudinal',
  [CHANNEL_SUBCATEGORIES.MULTI]: 'Multi',
  [CHANNEL_SUBCATEGORIES.VIRTUAL_CLINIC]: 'PA Virtual',
  [CHANNEL_SUBCATEGORIES.SCREENING]: 'Triagem'
}

export const CHANNEL_SUBCATEGORY_CLASSIFIERS_LABEL = {
  [CHANNEL_SUBCATEGORY_CLASSIFIERS.HEALTH_TEAM]: 'Time de saúde',
  [CHANNEL_SUBCATEGORY_CLASSIFIERS.NUTRITION]: 'Nutrição',
  [CHANNEL_SUBCATEGORY_CLASSIFIERS.PHYSICAL_PREPARATION]: 'Preparação física',
  [CHANNEL_SUBCATEGORY_CLASSIFIERS.PSYCHOLOGY]: 'Psicologia',
  [CHANNEL_SUBCATEGORY_CLASSIFIERS.AI]: 'IA'
}

export const CHANNEL_TYPE_CONFIG_OPTIONS = [
  {
    label: 'Assistencial agudo',
    value: {
      category: CHANNEL_CATEGORIES.ASSISTANCE,
      subCategory: CHANNEL_SUBCATEGORIES.ACUTE,
      subCategoryClassifier: null
    }
  },
  {
    label: 'Assistencial longitudinal',
    value: {
      category: CHANNEL_CATEGORIES.ASSISTANCE,
      subCategory: CHANNEL_SUBCATEGORIES.LONGITUDINAL,
      subCategoryClassifier: null
    }
  },
  {
    label: 'Administrativo',
    value: {
      category: CHANNEL_CATEGORIES.ADMINISTRATIVE,
      subCategory: null,
      subCategoryClassifier: null
    }
  }
]

export const CHANNEL_TYPE_CREATE_OPTIONS = [
  ...CHANNEL_TYPE_CONFIG_OPTIONS,
  {
    label: 'Nutrição',
    value: {
      category: CHANNEL_CATEGORIES.ASSISTANCE,
      subCategory: CHANNEL_SUBCATEGORIES.MULTI,
      subCategoryClassifier: CHANNEL_SUBCATEGORY_CLASSIFIERS.NUTRITION
    }
  },
  {
    label: 'Preparação física',
    value: {
      category: CHANNEL_CATEGORIES.ASSISTANCE,
      subCategory: CHANNEL_SUBCATEGORIES.MULTI,
      subCategoryClassifier:
        CHANNEL_SUBCATEGORY_CLASSIFIERS.PHYSICAL_PREPARATION
    }
  },
  {
    label: 'Psicologia',
    value: {
      category: CHANNEL_CATEGORIES.ASSISTANCE,
      subCategory: CHANNEL_SUBCATEGORIES.MULTI,
      subCategoryClassifier: CHANNEL_SUBCATEGORY_CLASSIFIERS.PSYCHOLOGY
    }
  }
]

export const ChannelStatus = {
  ACTIVE: 'ACTIVE',
  MERGED: 'MERGED',
  ARCHIVED: 'ARCHIVED'
}

export const ChannelStatusMap = {
  ACTIVE: 'Ativo',
  MERGED: 'Mesclado',
  ARCHIVED: 'Encerrado'
}

export const MessageTypes = {
  ADD_PARTICIPANT: 'ADD_PARTICIPANT',
  ANSWER: 'ANSWER',
  ARCHIVE_CHANNEL: 'ARCHIVE_CHANNEL',
  AUDIO: 'AUDIO',
  CHANNEL_ARCHIVED: 'CHANNEL_ARCHIVED',
  CHANNEL_MERGED: 'CHANNEL_MERGED',
  CHANNEL_RENAMED: 'CHANNEL_RENAMED',
  CHANNEL_UNARCHIVED: 'CHANNEL_UNARCHIVED',
  DOCUMENT: 'DOCUMENT',
  GIVE_OWNERSHIP: 'GIVE_OWNERSHIP',
  IMAGE: 'IMAGE',
  QUESTION: 'QUESTION',
  REMOVE_PARTICIPANT: 'REMOVE_PARTICIPANT',
  SPLIT_BAR: 'SPLIT_BAR',
  TEXT: 'TEXT',
  VIDEO: 'VIDEO',
  VISUALIZATION: 'VISUALIZATION',
  STARTED_QUESTIONNAIRE: 'STARTED_QUESTIONNAIRE',
  ENDED_QUESTIONNAIRE: 'ENDED_QUESTIONNAIRE',
  INTERNAL_REDIRECT: 'INTERNAL_REDIRECT'
}

export const USER_MESSAGE_TYPES = [
  MessageTypes.TEXT,
  MessageTypes.ANSWER,
  MessageTypes.QUESTION,
  MessageTypes.IMAGE,
  MessageTypes.AUDIO,
  MessageTypes.VIDEO,
  MessageTypes.DOCUMENT,
  MessageTypes.INTERNAL_REDIRECT
]

export const REPLY_MESSAGE_TYPES = [
  MessageTypes.IMAGE,
  MessageTypes.TEXT,
  MessageTypes.VIDEO,
  MessageTypes.DOCUMENT,
  MessageTypes.AUDIO
]

export const REACTION_MESSAGE_TYPES = REPLY_MESSAGE_TYPES

export const FILE_MESSAGE_TYPES = [
  MessageTypes.AUDIO,
  MessageTypes.DOCUMENT,
  MessageTypes.IMAGE,
  MessageTypes.VIDEO
]

export const PillarsMenu = {
  CLOSED: 'CLOSED',
  COMPACT: 'COMPACT',
  EXPANDED: 'EXPANDED'
}

export const PILLAR_MENU_TAB = {
  CHAT: 'chat',
  CHANNEL: 'channel',
  SEARCH: 'search'
}

export const isPillarMenuTab = value => {
  return !!Object.keys(PILLAR_MENU_TAB).find(
    key => PILLAR_MENU_TAB[key] === value
  )
}

export const NotificationsTabs = {
  ongoing: 'ongoing',
  open: 'open',
  mentions: 'mentions'
}

export const NotificationsTabsMap = {
  ongoing: 'Em andamento',
  open: 'Canais abertos',
  mentions: 'Pra você'
}

export const MessageFocus = {
  NONE: 'NONE',
  NEWEST: 'NEWEST',
  LATEST_SYNCED: 'LATEST_SYNCED',
  PAGINATION: 'PAGINATION'
}

export const CHAT_TITLE = 'Chat em andamento'

export const sortByMap = [
  {
    type: 'waiting-since-asc',
    label: 'Aguardando há mais tempo',
    firestoreSort: [
      {
        field: 'isWaiting',
        direction: 'desc'
      },
      {
        field: 'waitingSince',
        direction: 'asc'
      }
    ]
  },
  {
    type: 'waiting-since-desc',
    label: 'Aguardando há menos tempo',
    firestoreSort: [
      {
        field: 'isWaiting',
        direction: 'desc'
      },
      {
        field: 'waitingSince',
        direction: 'desc'
      }
    ]
  },
  {
    type: 'time-last-message-desc',
    label: 'Última atualização',
    firestoreSort: [
      {
        field: 'timeLastMessage',
        direction: 'desc'
      }
    ]
  },
  {
    type: 'total-unread-messages-desc',
    label: 'Mensagens não lidas',
    firestoreSort: [
      {
        field: 'totalUnreadMessages',
        direction: 'desc'
      }
    ]
  }
]

const appointmentFilter = {
  id: 1,
  selected: false,
  name: 'Sem consulta vinculada',
  filters: [
    {
      field: 'hasAppointment',
      operation: '==',
      value: false
    },
    {
      field: 'category',
      operation: '==',
      value: CHANNEL_CATEGORIES.ASSISTANCE
    }
  ]
}

//Separate filters by kind
export const chatStatusFilters = [appointmentFilter]

export const STAFF_STATUS = {
  AVAILABLE: 'AVAILABLE',
  UNAVAILABLE: 'UNAVAILABLE',
  BUSY: 'BUSY'
}

export const STAFF_STATUS_LABEL = {
  [STAFF_STATUS.AVAILABLE]: 'Online',
  [STAFF_STATUS.BUSY]: 'Ocupado',
  [STAFF_STATUS.UNAVAILABLE]: 'Ausente'
}

export const STAFF_STATUS_OPTIONS = [
  {
    label: STAFF_STATUS_LABEL.AVAILABLE,
    value: STAFF_STATUS.AVAILABLE,
    description: 'Disponível para receber novos atendimentos'
  },
  {
    label: STAFF_STATUS_LABEL.BUSY,
    value: STAFF_STATUS.BUSY,
    description:
      'Utilize quando estiver conduzindo um caso complexo ou se preparando para almoçar/ir embora'
  },
  {
    label: STAFF_STATUS_LABEL.UNAVAILABLE,
    value: STAFF_STATUS.UNAVAILABLE,
    description: 'Você não receberá novos atendimentos'
  }
]

export const VIDEOCALL_STATUS_CONTROL = {
  VIDEO_CALL_REJECTED: 'VIDEO_CALL_REJECTED',
  READY_TO_START_VIDEO_CALL: 'READY_TO_START_VIDEO_CALL',
  VIDEO_CALL_FINISHED: 'VIDEO_CALL_FINISHED',
  VIDEO_CALL_IN_PROGRESS: 'VIDEO_CALL_IN_PROGRESS',
  MISSING_MEMBER_INTERACTION: 'MISSING_MEMBER_INTERACTION',
  MEMBER_QUEUE_EXPERIENCE_READY_TO_START_VIDEO_CALL:
    'MEMBER_QUEUE_EXPERIENCE_READY_TO_START_VIDEO_CALL',
  DROP_BEFORE_VIDEO_CALL: 'DROP_BEFORE_VIDEO_CALL',
  MEMBER_LEFT_VIDEO_CALL: 'MEMBER_LEFT_VIDEO_CALL'
}
